import { useCookies } from 'react-cookie';
import { RESULT } from '../constants/cookies';

const expires = new Date();
expires.setTime(expires.getTime() + 86400000);

const useResult = () => {
  const [cookies, setCookie] = useCookies([RESULT]);

  const result = cookies[RESULT] || {};

  const setResult = val => setCookie(RESULT, { ...val }, { expires });

  return { result, setResult };
};

export default useResult;
